import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreviousStateService {

  public previousState:any;

  constructor() { }
}
